import { Api } from './api';

export class ReferalsApi {
    private static readonly PATH = '/referals';

    constructor(private readonly m_api: Api) {}

    public async getReferals() {
        return this.m_api.get(ReferalsApi.PATH);
    }

    public async getInviteMessage() {
        return this.m_api.get(`${ReferalsApi.PATH}/invite-message`);
    }
}
